var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"h_75"},[_c('m-img',{attrs:{"src":require("@/v2/mobile/assets/image/h_75.jpg")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }